<template>
  <button class="ds-input-close-button" type="button" @click.prevent.stop="$emit('click', $event)">
    <DsSvgIcon icon="x-circle" />
  </button>
</template>

<script setup lang="ts">
defineEmits<{
  (ev: 'click', payload: MouseEvent): void;
}>();
</script>

<style scoped>
.ds-input-close-button {
  @apply tw-inline-flex tw-flex-none tw-items-center tw-justify-center tw-text-grey-400;
  @apply tw-outline-none;
}
</style>
